import { render, staticRenderFns } from "./AddRecipient.vue?vue&type=template&id=4af6720b&scoped=true&"
import script from "./AddRecipient.vue?vue&type=script&lang=js&"
export * from "./AddRecipient.vue?vue&type=script&lang=js&"
import style0 from "./AddRecipient.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AddRecipient.vue?vue&type=style&index=1&id=4af6720b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af6720b",
  null
  
)

export default component.exports